import { enumSubChartFlag } from "../constants";
import { QClipboardBreakList } from "./QClipboardBreakList";
import { PopulateBreakEntry } from "./PopulateBreakEntry";

export function AddToSCBreakList(scNode, tempList, finalList) {
  var layout = scNode.GetLayout();
  var scFlag1 = layout.GetSubChartFlag();
  if (scFlag1 == enumSubChartFlag.nobreak) return;

  var n = tempList.length;
  var dbObj1 = scNode.GetDataObj();
  for (var i = 0; i < n; i++) {
    var scNode2 = tempList[i];
    var dbObj2 = scNode2.GetDataObj();
    if (dbObj1 == dbObj2) {
      var breakEntry = new QClipboardBreakList();
      PopulateBreakEntry(breakEntry, scNode);
      PopulateBreakEntry(breakEntry, scNode2);
      finalList.push(breakEntry);
      return;
    }
  }

  tempList.push(scNode);
}
